import { createSelector } from '@ngrx/store';
import { AccountsNotificationState, createAccountsNotificationState } from './accounts-notifications.reducer';

export const selectAutoPayState = createSelector(createAccountsNotificationState, (state: AccountsNotificationState) =>
  state ? state.autoPay : null
);

export const selectAutoPay = createSelector(selectAutoPayState, (state) => state?.response);
